import React, { useEffect, useState } from 'react';
import { ProfileData } from 'views/profiles/types/profile.types';

import { Outlet, Navigate } from 'react-router-dom';
import { useLazyQuery } from '@apollo/client';

import { ALL_PROFILES } from 'graphql/profiles/profiles.query';
import { getUser } from 'utils/user';

interface ProtectedRoute {
  page: string;
  action: string;
}

const ProtectedRoute: React.FC<ProtectedRoute> = ({ page, action }) => {
  const { role } = getUser();

  const [profiles, setProfiles] = useState<ProfileData[]>([]);

  const [load, { loading, data }] = useLazyQuery(ALL_PROFILES);

  const userRole = role || '';

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      load();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return () => (mounted = false as any);
  }, [load]);

  useEffect(() => {
    if (data) {
      setProfiles(data.allProfiles.result);
    }
  }, [data]);

  if (loading || !profiles.length) return <></>;

  const rolePermissions = profiles.find((profile) => profile.name === userRole);
  const permissions: Record<string, string[] | undefined> = rolePermissions?.permissions || ({} as Record<string, string[]>);

  if (!permissions || !permissions[page] || !permissions[page]?.includes(action)) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
